import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import images from "../../assets";
import "./styles.css";

export default function BottomBarMenu() {
  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;

  const profileData = useSelector((state) => state.profile?.profile);
  const { notifications } = useSelector((state) => state.notifications);
  const { userList } = useSelector((state) => state.message);

  const [allRead, setAllRead] = useState(true);
  const [messageCount, setMessageCount] = useState(0);

  useEffect(() => {
    const hasUnread = notifications.some(
      (notification) => notification.status === "unread"
    );
    setAllRead(!hasUnread);
  }, [notifications]);

  useEffect(() => {
    let unreadCount = 0;
    userList?.map((user) => {
      if (user.lastSenderId !== profileData.username && user.lastMessageRead) {
        unreadCount++;
      }
    });
    setMessageCount(unreadCount);
  }, [userList]);

  return (
    <div className="bottom-bar-container">
      <div
        onClick={() => navigate(`/`)}
        className={`${
          pathname.includes(`/dashboard`) ? "active" : ""
        } bottom-menu-bar`}
      >
        <img src={images.bottomBarHomeBlack} alt="Home" />
        <h3>Dashboard</h3>
      </div>
      <div
        onClick={() => navigate(`/advanced-search`)}
        className={`${
          pathname.includes(`/advanced-search`) ? "active" : ""
        } bottom-menu-bar`}
      >
        <img src={images.bottomBarSearchWhite} alt="Search" />
        <h3>Search</h3>
      </div>
      <div
        onClick={() => navigate(`/notifications`)}
        className={`${
          pathname.includes(`/notifications`) ? "active" : ""
        } bottom-menu-bar`}
      >
        <img src={images.bottomBarBellWhite} alt="Notify" />
        {!allRead && (
          <img
            className="bottom-menu-bar-noti-icon"
            src={images.notifyIcon}
            alt="Nofify"
          />
        )}
        <h3>Notifications</h3>
      </div>
      <div onClick={() => navigate(`/messages`)} className="bottom-menu-bar">
        <img src={images.bottomBarMegWhite} alt="Messages" />
        {messageCount > 0 && (
          <img
            className="bottom-menu-bar-noti-icon"
            src={images.notifyIcon}
            alt="Messages"
          />
        )}
        <h3>Messages</h3>
      </div>
    </div>
  );
}
